"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const WarningsComponent_vue_1 = __importDefault(require("@/client/components/WarningsComponent.vue"));
const LogMessageDataType_1 = require("@/common/logs/LogMessageDataType");
const CardOrderStorage_1 = require("@/client/utils/CardOrderStorage");
const Card_vue_1 = __importDefault(require("@/client/components/card/Card.vue"));
const ActiveCardsSortingOrder_1 = require("@/client/utils/ActiveCardsSortingOrder");
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectCard',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
            required: false,
            default: false,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            cards: [],
            warning: undefined,
            owners: new Map(),
            warnings: undefined,
        };
    },
    components: {
        Card: Card_vue_1.default,
        WarningsComponent: WarningsComponent_vue_1.default,
        AppButton: AppButton_vue_1.default,
    },
    watch: {
        cards() {
            this.$emit('cardschanged', this.getData());
        },
    },
    methods: {
        cardsSelected() {
            if (Array.isArray(this.cards)) {
                return this.cards.length;
            }
            else if (this.cards === undefined) {
                return 0;
            }
            return 1;
        },
        getOrderedCards() {
            let cards = [];
            if (this.playerinput.cards !== undefined) {
                if (this.playerinput.selectBlueCardAction) {
                    cards = (0, ActiveCardsSortingOrder_1.sortActiveCards)(this.playerinput.cards);
                }
                else {
                    cards = CardOrderStorage_1.CardOrderStorage.getOrdered(CardOrderStorage_1.CardOrderStorage.getCardOrder(this.playerView.id), this.playerinput.cards);
                }
            }
            if (this.playerinput.showOwner) {
                this.owners.clear();
                this.playerinput.cards.forEach((card) => {
                    const owner = this.findOwner(card);
                    if (owner !== undefined)
                        this.owners.set(card.name, owner);
                });
            }
            return cards;
        },
        getData() {
            return Array.isArray(this.$data.cards) ? this.$data.cards.map((card) => card.name) : [this.$data.cards.name];
        },
        hasCardWarning() {
            if (Array.isArray(this.cards)) {
                if (this.cards.length === 1) {
                    this.warnings = this.cards[0].warnings;
                }
                return false;
            }
            else if (typeof this.cards === 'object') {
                this.warnings = this.cards.warnings;
            }
            return false;
        },
        canSave() {
            const len = this.getData().length;
            if (len > this.playerinput.min) {
                return false;
            }
            if (len < this.playerinput.max) {
                return false;
            }
            return true;
        },
        saveData() {
            this.onsave({ type: 'card', cards: this.getData() });
        },
        getCardBoxClass(card) {
            if (this.playerinput.showOwner && this.getOwner(card) !== undefined) {
                return 'cardbox cardbox-with-owner-label';
            }
            return 'cardbox';
        },
        findOwner(card) {
            for (const player of this.playerView.players) {
                if (player.tableau.find((c) => c.name === card.name)) {
                    return { name: player.name, color: player.color };
                }
            }
            return undefined;
        },
        getOwner(card) {
            return this.owners.get(card.name) ?? { name: 'unknown', color: 'neutral' };
        },
        isCardActivated(card) {
            return this.playerView.thisPlayer.actionsThisGeneration.includes(card.name);
        },
        buttonLabel() {
            if (this.selectOnlyOneCard) {
                return this.playerinput.buttonLabel;
            }
            return {
                message: this.playerinput.buttonLabel + ' ${0}',
                data: [{
                        type: LogMessageDataType_1.LogMessageDataType.RAW_STRING,
                        value: String(this.cardsSelected()),
                    }],
            };
        },
        robotCard(card) {
            return this.playerView.thisPlayer.selfReplicatingRobotsCards?.find((r) => r.name === card.name);
        },
        toggleSelectAll() {
            if (this.allSelected) {
                this.cards = [];
            }
            else {
                this.cards = this.selectableCards.slice();
            }
        },
    },
    computed: {
        selectOnlyOneCard() {
            return this.playerinput.max === 1 && this.playerinput.min === 1;
        },
        isOptionalToManyCards() {
            return this.playerinput.max !== undefined &&
                this.playerinput.max > 1 &&
                this.playerinput.min === 0;
        },
        selectableCards() {
            return this.playerinput.cards.filter((card) => !card.isDisabled);
        },
        showSelectAll() {
            return this.playerinput.showSelectAll === true &&
                !this.selectOnlyOneCard &&
                this.selectableCards.length > 1;
        },
        allSelected() {
            return Array.isArray(this.cards) && this.cards.length === this.selectableCards.length;
        },
    },
});
